import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import ProgramList from "../components/ProgramList.vue";
export default {
  components: {
    ProgramList: ProgramList
  },
  data: function data() {
    return {
      programList: [{
        title: "authorityManagement_title",
        intro: "authorityManagement_intro",
        remark: "authorityManagement_remark",
        link: "/authorityManagement",
        poster: "https://cdn.steemitimages.com/DQmQi3MZkKcf2pMzb64c7F7NmMShrvybyzpvBBVwN6jRGy7/image.png",
        joinType: 0,
        //跳转页面加入
        joinItem: "AuthorityManagement",
        id: "0"
      }, {
        title: "autoClaimReward_title",
        intro: "autoClaimReward_intro",
        remark: "autoClaimReward_remark",
        link: "",
        poster: "https://cdn.steemitimages.com/DQmWPZaYTsG1iJHJ151VmSEKf89U4Y3gnDuU5wkXAXhY87N/image.png",
        joinType: 1,
        //当前页面加入
        joinItem: "isAutoClaimReward",
        username: "boylikegirl.club",
        id: "1"
      }, {
        title: "autoFollowClubVote_title",
        intro: "autoFollowClubVote_intro",
        remark: "autoFollowClubVote_remark",
        link: "",
        poster: "https://cdn.steemitimages.com/DQmTzyjpAZ7XbXrLyesmitxwiAAZdq7uDuFjhdsBSkKT2pQ/image.png",
        joinType: 1,
        //当前页面加入
        joinItem: "isAutoFollowClubVote",
        username: "boylikegirl.club",
        id: "2"
      }]
    };
  },
  methods: {},
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};